export const DEFAULT_PRODUCT_SORT_BY = 'created_at';
export const DEFAULT_PRODUCT_SORT_ORDER = 'desc';

export const EMPTY_PRODUCT_SUMMARY = {
    total_products: 0,
    min_price: 0,
    max_price: 0,
    average_price: 0,
    total_sales_quantity: 0,
    total_stock_quantity: 0,
    top_products: [],
};

export function buildProductsSummaryQuery({ q }) {
    const params = new URLSearchParams();
    if (q) {
        params.set('q', String(q));
    }
    return params.toString();
}
